import { Component, ViewChild } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { PhotoCropperComponent } from "../../photo-cropper/photo-cropper.component";

@Component({
  selector: "app-edit-profile-image-modal",
  templateUrl: "./edit-profile-image-modal.component.html",
  styleUrls: ["./edit-profile-image-modal.component.scss"],
})
export class EditProfileImageModalComponent {
  @ViewChild(PhotoCropperComponent, { static: false })
  public photoCropper: PhotoCropperComponent;

  constructor(private modalController: ModalController) {}

  closeModal() {
    this.modalController.dismiss();
  }

  onPrimaryAction() {
    if (!this.photoCropper) {
      return;
    }

    if (this.photoCropper.showCropper) {
      this.photoCropper.saveImage();
      return;
    }

    this.photoCropper.openImageSelector();
  }
}
